"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const motionTexts_1 = require("./motionTexts");
const viewMode_1 = require("./domain/viewMode");
let InaxMotionTextsPipe = class InaxMotionTextsPipe {
    constructor(_inaxMotionTexts) {
        this._inaxMotionTexts = _inaxMotionTexts;
    }
    transform(value, ...options) {
        try {
            if (options.length > 0) {
                let motion = options[0];
                if (motion != null) {
                    switch (value) {
                        case "DisplayName":
                            if (this.getViewMode(options) == viewMode_1.ViewMode.Symbolic)
                                return this._inaxMotionTexts.getSymbolicName(motion);
                            else
                                return "DB" + motion.BlockNum + ".DBB" + motion.BlockOffset;
                        case "Direction1Text":
                            return this._inaxMotionTexts.getDirection1Text(motion);
                        case "Direction2Text":
                            return this._inaxMotionTexts.getDirection2Text(motion);
                        case "FinalPositionText":
                            {
                                let finalPosition = options[1];
                                if (finalPosition != null) {
                                    if (this.getViewMode(options) == viewMode_1.ViewMode.Symbolic)
                                        return this._inaxMotionTexts.getFinalPositionText(motion, finalPosition);
                                    else
                                        return finalPosition.AbsoluteAddress;
                                }
                            }
                    }
                }
            }
        }
        catch (error) {
            console.log(error);
        }
        return value;
    }
    getViewMode(options) {
        let vm = options[options.length - 1];
        if (vm != null)
            return vm;
        return viewMode_1.ViewMode.Symbolic;
    }
};
InaxMotionTextsPipe = __decorate([
    core_1.Pipe({ name: 'motionTexts' }),
    __metadata("design:paramtypes", [motionTexts_1.InaxMotionTextsService])
], InaxMotionTextsPipe);
exports.InaxMotionTextsPipe = InaxMotionTextsPipe;
